
import React from 'react'
import { usePageTitle } from '@/stores/page-title-store'

export default function JanesTestPage() {
  usePageTitle('Manu - Assistente IA')

  return (

      <div className="space-y-6">
        <div className="bg-brand-dark-light rounded-lg border border-gray-700 p-6">
          <div className="text-center space-y-4">
            <div className="w-20 h-20 bg-brand-primary rounded-full flex items-center justify-center mx-auto">
              <span className="text-3xl font-bold text-brand-dark">M</span>
            </div>

            <h2 className="text-xl font-semibold text-white">
              Olá! Eu sou a Manu
            </h2>

            <p className="text-gray-300 max-w-2xl mx-auto">
              Sua assistente de dados da Monumenta. Posso responder perguntas sobre:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
              <div className="bg-brand-dark p-4 rounded-lg border border-gray-700">
                <h3 className="text-brand-primary font-semibold mb-2">Dados Financeiros</h3>
                <p className="text-sm text-gray-300">
                  Receitas de clientes, projetos, performance comparativa e métricas financeiras
                </p>
              </div>

              <div className="bg-brand-dark p-4 rounded-lg border border-gray-700">
                <h3 className="text-brand-primary font-semibold mb-2">Estrutura Organizacional</h3>
                <p className="text-sm text-gray-300">
                  Informações sobre colaboradores, departamentos e hierarquia da empresa
                </p>
              </div>

              <div className="bg-brand-dark p-4 rounded-lg border border-gray-700">
                <h3 className="text-brand-primary font-semibold mb-2">Performance e Projetos</h3>
                <p className="text-sm text-gray-300">
                  Análises de projetos, clientes e comparativos de performance
                </p>
              </div>
            </div>

            <div className="mt-8 p-4 bg-brand-primary/10 rounded-lg border border-brand-primary/30">
              <p className="text-brand-primary font-medium">
                Para conversar comigo, clique no botão "Pergunta pra Manu" no menu lateral!
              </p>
              <p className="text-sm text-gray-300 mt-2">
                Você pode digitar suas próprias perguntas ou usar o botão para perguntas aleatórias.
              </p>
            </div>

            <div className="mt-6">
              <h3 className="text-lg font-semibold text-white mb-4">Exemplos de perguntas:</h3>
              <div className="space-y-2 text-left">
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Quantas pessoas tem na área de criação?"</p>
                </div>
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Quais são as pessoas que estão na área presidencia?"</p>
                </div>
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Qual foi a receita do projeto Portal Web Responsivo?"</p>
                </div>
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Quanto foi a receita do Banco do Brasil em 2025?"</p>
                </div>
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Como foi a performance do cliente Apex-Brasil?"</p>
                </div>
                <div className="bg-gray-700 p-3 rounded-lg">
                  <p className="text-sm text-gray-300">"Quantos colaboradores temos no departamento comercial?"</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  )
}
